import { createTheme } from '@mui/material';

export const theme = createTheme({
    components: {
        MuiOutlinedInput: {
            defaultProps: {
                sx: {
                    backgroundColor: (theme) => theme.palette.common.white,
                },
            },
        },
        MuiPaper: {
            defaultProps: {
                sx: {
                    backgroundColor: (theme) => theme.palette.grey[100],
                },
            },
        },
        MuiButton: {
            defaultProps: {
                disableRipple: true,
            },
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
        MuiToggleButton: {
            styleOverrides: {
                root: {
                    textTransform: 'none',
                },
            },
        },
    },
});
